import { render, staticRenderFns } from "./past-due.vue?vue&type=template&id=4ae0d0e0&"
import script from "./past-due.vue?vue&type=script&lang=ts&"
export * from "./past-due.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports